import { render, staticRenderFns } from "./UiCurrenciesList.vue?vue&type=template&id=28e9a969&lang=pug&"
import script from "./UiCurrenciesList.vue?vue&type=script&lang=js&"
export * from "./UiCurrenciesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports